import { Button } from 'shared/ui/Button';
import { MaterialIcon } from 'shared/ui/MaterialIcon';

export function NotAvailableModal() {
  return (
    <div className="px-[25px] pt-5">
      <div className="absolute left-1/2 top-38 z-10 flex w-[468px] -translate-x-1/2 flex-col rounded-md bg-white px-12 pb-10 pt-[30px] text-center shadow-modal">
        <div className="text-center">
          <MaterialIcon className="text-[60px] text-slate-800">lock</MaterialIcon>
        </div>
        <div className="mt-3 text-xl font-bold">
          This report is only available to contractors who share their disposition data.
        </div>
        <div className="mt-2 text-sm">If you already do, contact your PM to get access.</div>
        <div className="text-sm">If not, you can start sharing it now.</div>
        <Button
          className="mt-[30px]"
          onClick={() => window.open('https://datacenter.homebuddy.com/', '_blank')}
        >
          Share data
        </Button>
      </div>
    </div>
  );
}
